import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { ITagsViewState } from './modules/tags-view';
import { IUserState } from './modules/user';
import { IPermissionState } from './modules/permission';
import { IBookingState } from './modules/booking';
import { IReportState } from './modules/report';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  booking: IBookingState;
  permission: IPermissionState;
  report: IReportState;
  tagsView: ITagsViewState;
  user: IUserState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
